import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Grid,
  List,
  ListItem,
  ListItemText,
  Box,
} from '@mui/material';

interface PurchaseDialogProps {
  open: boolean;
  onClose: () => void;
  onNavigate: (path: string) => void;
  productId: string | null;
  products: any[];
}

const PurchaseDialog: React.FC<PurchaseDialogProps> = ({
  open,
  onClose,
  onNavigate,
  productId,
  products,
}) => {
  if (!products) return null;
  const subscriptions = products.filter((p) => p.category === 'Subscription');

  const [singleHostApp] = subscriptions.filter(
    (p) => p.name.toLowerCase().indexOf('single host') >= 0,
  );

  const [allAccess] = subscriptions.filter(
    (p) => p.name.toLowerCase().indexOf('all access') >= 0,
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="purchase-dialog-title"
      aria-describedby="purchase-dialog-description"
      maxWidth="md"
      fullWidth
    >
      {/* <DialogTitle id="purchase-dialog-title">Purchase Video Plugin</DialogTitle> */}
      <DialogContent>
        <Grid container spacing={2} alignItems="stretch">
          <Grid
            item
            xs={12}
            sm={6}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="h6" align="center">
                Subscription
              </Typography>
              <List style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                <ListItem style={{ display: 'list-item' }}>
                  <ListItemText primary="Access to all our plugins for 12 months: Beauty Box, Flicker Free, Samurai Sharpen, Data Storyteller, Transcriptive Rough Cutter, and Light Wrap Fantastic." />
                </ListItem>
                <ListItem style={{ display: 'list-item' }}>
                  <ListItemText primary="Access to any new plugins we release at no additional cost" />
                </ListItem>
                <ListItem style={{ display: 'list-item' }}>
                  <ListItemText primary="Unlimited Phone and Email support from our San Francisco based team" />
                </ListItem>
                <ListItem style={{ display: 'list-item' }}>
                  <ListItemText primary="Updates and Upgrades for all plugins are included. Important for bug fixes and any changes to host apps or OS." />
                </ListItem>
              </List>
            </Box>
            <Box display="flex" justifyContent="space-between">
              {singleHostApp && (
                <Button
                  onClick={() => onNavigate(`/purchase/${singleHostApp._id}`)}
                  color="primary"
                  variant="contained"
                  style={{ marginRight: '10px', flex: 1 }}
                >
                  Subscribe to One Host App
                </Button>
              )}
              {allAccess && (
                <Button
                  onClick={() => onNavigate(`/purchase/${allAccess._id}`)}
                  color="primary"
                  variant="contained"
                  style={{ marginRight: '10px', flex: 1 }}
                >
                  Subscribe to All Access
                </Button>
              )}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="h6" align="center">
                Perpetual License
              </Typography>
              <List style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                <ListItem style={{ display: 'list-item' }}>
                  <ListItemText primary="You get one year of free updates and upgrades" />
                </ListItem>
                <ListItem style={{ display: 'list-item' }}>
                  <ListItemText primary="Only includes one plugin." />
                </ListItem>
                <ListItem style={{ display: 'list-item' }}>
                  <ListItemText primary="One year of Phone and Email support." />
                </ListItem>
                <ListItem style={{ display: 'list-item' }}>
                  <ListItemText primary="May require an upgrade fee after one year if changes to the host app or OS break the plugin. (this probably happens every five+ years but is a bit more frequent on Mac as Apple has a habit of breaking things or removing things the plugins rely on (like OpenCL)." />
                </ListItem>
              </List>
            </Box>
            <Box display="flex" justifyContent="center">
              <Button
                onClick={() => onNavigate(`/purchase/${productId}`)}
                color="primary"
                variant="contained"
                fullWidth
              >
                Buy Plugin Only
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PurchaseDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  productId: PropTypes.string,
};

export default PurchaseDialog;
